import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DelonABCModule } from '@delon/abc';
import { DelonACLModule } from '@delon/acl';
import { DelonFormModule } from '@delon/form';
import { AlainThemeModule } from '@delon/theme';
import { TranslateModule } from '@ngx-translate/core';
import { ControlMessagesComponent } from '@shared/components/form/control-messages.component';
import { ExportButtonComponent } from '@shared/components/form/export-button.component';
import { PageHeaderComponent } from '@shared/components/layout/page-header.component';
import { I18nLanguageSelectionComponent } from '@shared/configs/i18n/i18n.language-selection.component';
import { TextMaskModule } from 'angular2-text-mask';
import { NgBrazil } from 'ng-brazil';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { FilterComponent } from './components/filter/filter.component';
import { BooleanDisplayComponent } from './components/form/boolean-display.component';
import { FormItemComponent } from './components/form/form-item.component';
import { PasswordResetComponent } from './components/password-reset/password-reset.component';
import { MaskDirective } from './directives/mask.directive';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { DateFieldComponent } from './components/form/date-field.component';
import { FormItemEnumComponent } from './components/form/form-item-enum.component';
import { CurrencyMaskModule } from "ng2-currency-mask";
import { TableDocumentsComponent } from './components/table-documents/table-documents.component';
import { SecurePipe } from './pipes/secure.pipe';
import { DateInssPipe } from './pipes/date-inss.pipe';

const THIRDMODULES = [NgZorroAntdModule, CurrencyMaskModule];
// #endregion

// #region your componets & directives
const COMPONENTS = [
  ControlMessagesComponent,
  PageHeaderComponent,
  FilterComponent,
  BooleanDisplayComponent,
  ExportButtonComponent,
  I18nLanguageSelectionComponent,
  PasswordResetComponent,
  FormItemComponent,
  FormItemEnumComponent,
  BooleanDisplayComponent,
  FileUploadComponent,
  DateFieldComponent,
  TableDocumentsComponent
];
const DIRECTIVES = [MaskDirective];
const PIPES = [SecurePipe, DateInssPipe];
// #endregion

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    AlainThemeModule.forChild(),
    DelonABCModule,
    DelonACLModule,
    DelonFormModule,
    TranslateModule,
    NgBrazil,
    TextMaskModule,
    // third libs
    ...THIRDMODULES,
  ],
  declarations: [
    // your components
    ...COMPONENTS,
    ...DIRECTIVES,
    ...PIPES,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    AlainThemeModule,
    DelonABCModule,
    DelonACLModule,
    DelonFormModule,
    NgBrazil,
    TextMaskModule,
    // i18n
    TranslateModule,
    // third libs
    ...THIRDMODULES,
    // your components
    ...COMPONENTS,
    ...DIRECTIVES,
    ...PIPES
  ],
})
export class SharedModule {}
